export enum FormType {
	EDIT,
	ADD,
	DERIVATE,
	DELETE,
	RESTORE,
}
